import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Copy, Tag, Percent } from "lucide-react";
import CustomerLayout from "@/components/customer/CustomerLayout";
import { RestaurantCard } from "@/components/customer/RestaurantCard";
import { BannerCarousel } from "@/components/customer/BannerCarousel";
import { SectionHeader, Rail } from "@/components/common";
import { api } from "@/lib/api";

export default function Offers() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/offers").then((r) => setData(r.data)).catch(() => {}); }, []);
  const copy = (c) => { navigator.clipboard?.writeText(c); toast.success(`${c} copied — apply it in cart`); };

  return (
    <CustomerLayout>
      <div className="bg-gradient-to-b from-coral to-coral-dark text-white px-5 pt-8 pb-5 rounded-b-3xl">
        <h1 className="font-display font-extrabold text-2xl">Offers & Coupons</h1>
        <p className="text-white/85 text-sm">Save more on every craving</p>
      </div>
      {!data ? <div className="p-4 space-y-3"><div className="skel h-40 rounded-2xl" /></div> : (
        <div className="py-4 space-y-6">
          <BannerCarousel banners={data.banners} />
          <div>
            <SectionHeader title="Coupons for you" />
            <div className="px-4 grid gap-3">
              {data.coupons.map((c) => (
                <div key={c.id} className="bg-white rounded-2xl border border-dashed border-coral p-4 flex items-center gap-3" data-testid={`coupon-${c.code}`}>
                  <div className="w-11 h-11 rounded-xl bg-coral-light flex items-center justify-center shrink-0"><Percent size={20} className="text-coral" /></div>
                  <div className="flex-1 min-w-0"><div className="font-bold text-ink">{c.title}</div><div className="text-xs text-ink-600 truncate">{c.description}</div><div className="text-[11px] text-ink-600 mt-0.5">Min order {c.min_order ? `₹${c.min_order}` : "—"}</div></div>
                  <button onClick={() => copy(c.code)} className="shrink-0 border border-coral text-coral font-bold text-xs px-3 py-2 rounded-lg flex items-center gap-1 tap" data-testid={`copy-${c.code}`}><Copy size={13} /> {c.code}</button>
                </div>
              ))}
            </div>
          </div>
          {data.restaurant_offers?.length > 0 && (
            <div>
              <SectionHeader title="Restaurants with offers" />
              <Rail>{data.restaurant_offers.map((r) => <RestaurantCard key={r.id} r={r} />)}</Rail>
            </div>
          )}
        </div>
      )}
    </CustomerLayout>
  );
}
